import { Flex, IconName, theme } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra, aloft/prefer-sound-ui-button
import { Button } from '@aloft/toolkit-sui/chakra';

import { forwardRef } from 'react';

import { isUndefined } from '@aloft/toolkit-shared';
import { PropertyGridFieldName } from '../../types.ts';
// eslint-disable-next-line aloft/prefer-sound-ui-button
import { sharedButtonStyle } from '../styles.ts';
// eslint-disable-next-line aloft/prefer-sound-ui-button
import { ConflictResolveButton } from './ConflictResolveButton.tsx';
import { SourceIconSlot } from './SourceIconSlot.tsx';
import { TruncatedText } from './TruncatedText.tsx';

type EditableFieldTriggerProps = {
  colSpan: number;
  displayValue?: string;
  fieldHasConflict: boolean;
  showConflictButton: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick?: () => void;
  propertyDataFieldName: string;
  conflictedFields: Record<string, { fieldName: PropertyGridFieldName; propertyId: string }>;
  showIcon: boolean;
  icon: IconName;
  iconTooltipLabel: string;
  required?: boolean;
};

export const EditableFieldTrigger = forwardRef<HTMLButtonElement, EditableFieldTriggerProps>(
  (
    {
      colSpan,
      displayValue,
      fieldHasConflict,
      showConflictButton,
      onMouseEnter,
      onMouseLeave,
      onClick,
      propertyDataFieldName,
      conflictedFields,
      showIcon,
      icon,
      iconTooltipLabel,
      required = false,
    },
    ref,
  ) => {
    let title: string | undefined;
    let backgroundColor = theme.colors.surface1;

    let border = 'none';
    if (isUndefined(displayValue) && required) {
      border = `1px solid ${theme.colors.alertError}`;
    }


    if (fieldHasConflict) {
      title = 'There is a data conflict. Please resolve.';
      backgroundColor = theme.colors.alertWarningLight;
    } else if (displayValue === undefined) {
      title = 'This field is empty. Please input a value.';
      backgroundColor = theme.colors.selected4;
    }

    return (
      <Button
        ref={ref}
        {...sharedButtonStyle}
        title={title}
        backgroundColor={backgroundColor}
        border={border}
        gridColumn={`span ${colSpan}`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
      >
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <TruncatedText>{displayValue}</TruncatedText>
          <Flex alignItems="center" gap="0.25rem">
            <ConflictResolveButton
              show={fieldHasConflict && showConflictButton}
              propertyDataFieldName={propertyDataFieldName}
              conflictedFields={conflictedFields}
            />
            <SourceIconSlot show={showIcon} icon={icon} tooltipLabel={iconTooltipLabel} />
          </Flex>
        </Flex>
      </Button>
    );
  },
);
